<template>
  <div>
    <headerd></headerd>
    <div>
      <div class="material-head">
        <img src="../../assets/img/material-img.png" alt />
        <div class="material-shadow"></div>
        <div class="material-div">
          <p>设计师招募进行中</p>
          <button @click="toCertification">立即申请</button>
        </div>
      </div>
      <div class="materialp-div ban">
        <div class="materialp-search">
          <i></i>
          <input type="text" @keyup.enter="onKeyup" v-model="serachName" placeholder="搜索设计师、插画、动漫…" />
        </div>
        <div class="design">
          <div class="partent-box" v-for="(item, index) in auther" :key="index">
            <div class="opus-box">
              <div class="author">
                <div class="author-portrait" @click="desginerDetail(item.id)">
                  <img v-if="item.avatar" :src="item.avatar" alt />
                  <img v-else src="../../assets/img/avatar-empty.png" alt />
                </div>
                <div class="author-flower"></div>
              </div>
              <div class="author-info">
                <p class="info">
                  <em>{{item.nickname}}</em>
                  <span>
                    <i class="male" v-if="item.gender == 'male'"></i>
                    <i class="famale" v-if="item.gender == 'famale'"></i>
                    <i v-show="item.birthday != null">{{item.birthday}}</i>
                  </span>
                  <!-- <span>插画</span> -->
                </p>
                <p class="local">{{item.city}}</p>
                <p class="descrip">{{item.sign}}</p>
                <p class="fans">
                  <span>
                    作品
                    <em>{{item.sourceCount}}</em>
                  </span>
                  <span>
                    关注者
                    <em>{{item.followerCount}}</em>
                  </span>
                </p>
                <button
                  class="follow-btn un-follow"
                  v-if="item.isfollow"
                  @click="cancleFollow(item.id)"
                >已关注</button>
                <button
                  class="follow-btn follow"
                  v-if="!item.isfollow"
                  @click="follow(item.id)"
                >关注</button>
              </div>
              <div class="author-opus">
                <li v-for="(item1, index1) in item.sources.slice(0,3)" :key="index1">
                  <a @click="sourceDetail(item1.id)">
                    <img :src="item1.url" alt />
                  </a>
                </li>
                <!-- <swiper :options="swiperoptinon">
                  <swiper-slide v-for="(item1, index1) in item.sources" :key="index1">
                    <img :src="item1.url" alt @click="sourceDetail(item1.id)" />
                  </swiper-slide>
                </swiper>-->
              </div>
            </div>
            <p class="more">
              <a @click="desginerDetail(item.id)">
                查看更多
                <i class="more-icon"></i>
              </a>
            </p>
          </div>
          <el-pagination
            class="page"
            @current-change="handleCurrentChange"
            :current-page="Queryinfo.pagenum"
            :page-sizes="[12]"
            :page-size="Queryinfo.pagesize"
            layout="pager"
            :total="total"
            v-show="autherShow"
            font-size="18px !important"
          ></el-pagination>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import bottom from "components/common/bottom.vue";
import headerd from "components/common/header.vue";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import qs from "qs";
import { getInfoByUrl } from "../../assets/globle.js";
import router from "../../assets/js/router";
import $ from "jquery";
export default {
  name: "app",
  components: {
    headerd,
    bottom,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data: function() {
    return {
      serachName: "",
      tag: "",
      auther: [],
      swiperoptinon: {
        slidesPerView: 3,
        spaceBetween: 30
        // grabCursor: true
      },
      autherId: "",
      total: 0,
      Queryinfo: {
        type: 10,
        // 当前的页码
        pagenum: 1,
        // 每页显示几条数据
        pagesize: 12
      },
      autherShow: false
    };
  },
  mounted() {},
  methods: {
    onKeyup() {
      this.key = this.serachName;
      this.getDesignerList();
    },
    async getDesignerList() {
      const res = await this.$http.get("/api/designer/list", {
        params: {
          key: this.key,
          page: this.Queryinfo.pagenum,
          limit: 12
        }
      });
      res.data.designers.forEach(item => {
        if (item.birthday != null) {
          var birthday = item.birthday.split("-")[0];
          var cloneBirthday = birthday.slice(2, 3);
          item.birthday = cloneBirthday + '0后'
        }
      });
      this.auther = res.data.designers;
      if(this.auther.length == 0){
        this.autherShow = false
      }else {
        this.autherShow = true
      }
      this.total = res.data.paginator.count
    },
    toCertification() {
      window.location.href = router.certIfication;
    },
    async sourceDetail(id) {
      window.open(router.opusDetail + "?id=" + id);
    },
    desginerDetail(id) {
      window.location.href = router.desginerInfo + "?uid=" + id;
    },
    async cancleFollow(uid) {
      const res = await this.$http.post(
        "/api/designer/unfollow",
        qs.stringify({
          uid: uid
        })
      );
      this.getDesignerList();
      this.$message.success("已取消关注");
    },
    async follow(uid) {
      const res = await this.$http.post(
        "/api/designer/follow",
        qs.stringify({
          uid: uid
        })
      );
      this.getDesignerList();
      this.$message.success("关注成功");
    },
    // 分页 监听 pagenum 改变
    handleCurrentChange: function(newnum) {
      this.Queryinfo.pagenum = newnum;
      this.getDesignerList();
    }
  },
  created: function() {
    this.getDesignerList();
  },
  beforeCreate: function() {}
};
</script>

<style lang="less" scoped>
.ban {
  width: 1200px;
  margin: 0 auto;
}
.material-head {
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .material-shadow {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .material-div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    p {
      font-size: 40px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 60px;
      margin-bottom: 10px;
    }
    button {
      width: 212px;
      height: 47px;
      border-radius: 1px;
      border: 1px solid rgba(255, 255, 255, 1);
      outline: none;
      cursor: pointer;
      font-size: 26px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 39px;
      background: none;
    }
    button:hover {
      background: rgba(110, 99, 232, 1) !important;
      color: rgba(255, 255, 255, 1) !important;
      border: 0 !important;
    }
  }
}
.materialp-div {
  margin-top: 40px;
  margin-bottom: 78px;
}
.materialp-search {
  position: relative;
  text-align: center;
  width: 471px;
  height: 45px;
  box-sizing: border-box;
  margin: 0 auto;
}
.materialp-search i {
  top: 11px;
  left: 39px;
  position: absolute;
  display: block;
  width: 20px;
  height: 22px;
  background: url(../../assets/img/sousuo.png) no-repeat;
  background-size: 20px 22px;
}
.materialp-search input {
  width: 471px;
  height: 45px;
  background: rgba(242, 241, 241, 1);
  border-radius: 32px 0px 32px 32px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-left: 88px;
  border: none;
  outline: none;
  font-size: 16px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 22px;
}
.design {
  height: 100%;
  margin-top: 17px;
}
.partent-box {
  width: 1200px;
  height: 230px;
  border-top: 1px solid rgba(229, 229, 229, 1);
  padding-top: 30px;
  box-sizing: border-box;
}
.partent-box:nth-child(1) {
  border-top: none;
}
.more {
  text-align: right;
  margin-top: 10px;
}
.more a {
  font-size: 16px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
  cursor: pointer;
}
.more a .more-icon {
  display: inline-block;
  width: 7px;
  height: 13px;
  background: url(../../assets/img/jiantou-right.png) no-repeat;
  background-size: 7px 13px;
}
.opus-box {
  overflow: hidden;
}
.opus-box div {
  float: left;
}
.author {
  position: relative;
  width: 110px;
  height: 108px;
  margin-top: 28px;
}
.author-portrait {
  position: absolute;
  top: 0;
  left: 0;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  cursor: pointer;
  img {
    width: 110px;
    height: 108px;
    border-radius: 50%;
  }
}
.author-flower {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 46px;
  height: 46px;
  background: url(../../assets/img/author-flower.png) no-repeat;
  background-size: 46px;
}
.author-info {
  width: 200px;
  margin: 0 49px 0 47px;
}
.info em {
  font-size: 18px;
  font-family: AlibabaSans-Regular, AlibabaSans;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.info span {
  display: inline-block;
  padding: 0 7px;
  height: 18px;
  background: rgba(242, 241, 241, 1);
  border-radius: 11px;
  text-align: center;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
}
.info i {
  font-style: normal;
}
.info .male {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url(../../assets/img/male.png) no-repeat;
  background-size: 14px 14px;
  margin-right: 5px;
  vertical-align: middle;
}
.info .famale {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url(../../assets/img/famale.png) no-repeat;
  background-size: 14px 14px;
  margin-right: 5px;
  vertical-align: middle;
}
.local {
  font-size: 16px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 22px;
  margin: 4px 0 0 0px;
}
.descrip {
  font-size: 16px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
}
.fans {
  margin: 6px 0 10px 0;
}
.fans span {
  font-size: 16px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
}
.fans em {
  font-size: 18px;
  font-family: AlibabaSans-Regular, AlibabaSans;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 28px;
}
.follow-btn {
  width: 103px;
  height: 28px;
  border-radius: 18px;
  outline: none;
  font-size: 18px;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
.follow {
  background: linear-gradient(
    92deg,
    rgba(231, 120, 194, 1) 0%,
    rgba(242, 159, 39, 1) 100%
  );
  color: rgba(255, 255, 255, 1);
  border: 0;
}
.un-follow {
  border: 1px solid rgba(151, 151, 151, 1);
  background: #fff;
  color: rgba(153, 153, 153, 1);
}
.author-opus {
  width: 794px;
  overflow: hidden;
  /deep/ .swiper-slide {
    width: 220px !important;
    height: 160px !important;
    cursor: pointer;
  }
}
.author-opus li {
  width: 220px;
  height: 160px;
  box-sizing: border-box;
  float: left;
  list-style: none;
  margin-left: 44px;
  a {
    cursor: pointer;
  }
}
.author-opus li img {
  width: 100%;
  height: 100%;
}
em {
  font-style: normal;
}
.page {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 40px;
  /deep/ .el-pager li {
    width: 28px;
    height: 28px;
    border-radius: 2px;
    border: 1px solid rgba(153, 153, 153, 1);
    font-size: 16px;
    font-family: DIN-Regular, DIN;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    min-width: 28px !important;
    margin-right: 15px;
  }
  /deep/ .el-pager li.active {
    width: 28px;
    height: 28px;
    background: rgba(51, 51, 51, 1);
    border-radius: 2px;
    font-size: 16px;
    font-family: DIN-Regular, DIN;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    min-width: 28px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/desginer/desginer.vue